import Section from '../base/Section';

export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      icon: 'ri-phone-line',
      title: 'Contacto y presupuesto',
      description: 'Llámanos o escríbenos por WhatsApp. Te respondemos en menos de 24 horas con un presupuesto sin compromiso adaptado a tus necesidades.'
    },
    {
      number: '2',
      icon: 'ri-eye-line',
      title: 'Visita gratuita',
      description: 'Visitamos el inmueble en Granollers o alrededores para evaluar el trabajo. La visita es totalmente gratuita y sin ningún tipo de compromiso.'
    },
    {
      number: '3',
      icon: 'ri-truck-line',
      title: 'Vaciado y limpieza',
      description: 'Realizamos el vaciado completo, retirada de enseres y limpieza extrema si es necesario. Trabajo rápido, eficiente y con total discreción.'
    },
    {
      number: '4',
      icon: 'ri-checkbox-circle-line',
      title: 'Entrega impecable',
      description: 'Entregamos el espacio completamente vacío y limpio, listo para alquilar, vender o reformar. Gestión completa de residuos incluida.'
    }
  ];

  return (
    <Section background="white" padding="lg">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
          Cómo trabajamos
        </h2>
        <p className="text-lg text-tertiary max-w-2xl mx-auto">
          Proceso simple y transparente en 4 pasos para tu tranquilidad
        </p>
      </div>

      <div className="relative">
        {/* Línea conectora - solo visible en desktop */}
        <div className="hidden lg:block absolute top-16 left-0 right-0 h-1 bg-gradient-to-r from-primary/20 via-primary to-primary/20"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              {/* Icono arriba del número */}
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className={`${step.icon} text-5xl text-tertiary`}></i>
              </div>
              
              {/* Número circular */}
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-white border-4 border-primary flex items-center justify-center relative z-10 shadow-lg">
                <span className="text-3xl font-bold text-primary">{step.number}</span>
              </div>

              {/* Contenido */}
              <h3 className="text-xl font-bold text-secondary mb-3">
                {step.title}
              </h3>
              <p className="text-tertiary leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
